<template>
	<div class="">
		<div class="d-flex flex-column gap-3 mb-5">
			<calculator_input_value_single @update="setSalary" @brutto="setBrutto" />
			<calculator_output_period @update="setPeriodMonth" />
		</div>

		<h5 class="mb-4 fwc-bold">{{ pll["My net income would be"] }}</h5>
		<calculator_output_currency class="bold-value" />

		<span v-if="brutto">
			<title_value class="mb-3 tv-bold" :title="pll['Gross Income']" :value="salary" />
			<div class="d-flex flex-column gap-1">
				<!-- <span class="h6 m-0 tv-bold">Taxes</span> -->

				<title_value class="tv-bold mt-1" :title="pll['Total taxes']" pre="-" :value="all_taxes" />
				<small role="button" v-if="!spoiler" @click="spoiler = !spoiler" class="d-block text-muted"> {{ pll["Show taxes"] }} → </small>
				<div v-if="spoiler">
					<title_value :title="pll['Sécurité Sociale déplafonnée']" pre="-" :value="uncapped_social_security" />
					<title_value :title="pll['Sécurité Sociale plafonnée']" pre="-" :value="capped_social_security" />
					<title_value :title="pll['Sécurité Sociale plafonnée']" pre="-" :value="capped_social_security" />
					<title_value :title="pll['Complémentaire santé - Tranche 1']" pre="-" :value="complementary_health_tranche_1" />
					<title_value :title="pll['Complémentaire santé - Tranche 2']" pre="-" :value="complementary_health_tranche_2" />
					<title_value :title="pll['Assurance chômage']" pre="-" :value="unemployment_insurance" />
					<title_value :title="pll['CSG imposable']" pre="-" :value="csd_taxable" />
					<title_value :title="pll['CSG non imposable']" pre="-" :value="csd_no_taxable" />
					<title_value :title="pll['CRDS']" pre="-" :value="crds" />
					<title_value :title="pll['Total Expenses']" pre="-" :value="total_expenses" />
					<title_value :title="pll['Net salary']" :value="net_salary" />
					<title_value :title="pll['Taxable salary']" :value="taxable_salary" />
					<title_value :title="pll['Impôt sur le revenu']" pre="-" :value="witholding_income_tax" />
				</div>
			</div>

			<!-- Output summ brutto -->
			<title_value class="fwc-bold mt-3" :title="pll['Total net income']" :value="month_period * total_net_income" />
		</span>

		<!-- Output summ netto -->
		<title_value v-else class="fwc-bold mt-3" :title="pll['Summ']" :value="month_period * salary" />
	</div>
</template>
<script>
import title_value from "./inc/title_value";
import custom_select from "./inc/custom_select";
import calculator_input_value_single from "./inc/calculator_input_value_single";
import calculator_output_currency from "./inc/calculator_output_currency";
import calculator_output_period from "./inc/calculator_output_period";
import currencies from "./mixins/currencies";

export default {
	components: {
		title_value,
		custom_select,
		calculator_input_value_single,
		calculator_output_currency,
		calculator_output_period,
	},
	mixins: [currencies],
	data() {
		return {
			salary: null,
			max_base: 3428,
			month_period: null,
			spoiler: false,
			currency_for_calculate_taxes: "EUR",
			brutto: true,
		};
	},
	computed: {
		// Base with condition max base
		base: function () {
			if (this.salary <= this.max_base) {
				return this.salary;
			} else {
				return this.max_base;
			}
		},
		// Sécurité Sociale déplafonnée
		uncapped_social_security: function () {
			return this.salary * 0.004;
		},
		// Sécurité Sociale plafonnée
		capped_social_security: function () {
			return this.base * 0.069;
		},
		// Complémentaire santé - Tranche 1
		complementary_health_tranche_1: function () {
			return this.base * 0.0315;
		},
		// Complémentaire santé - Tranche 2
		complementary_health_tranche_2: function () {
			if (this.salary > this.max_base) {
				return (this.salary - this.base) * 0.0864;
			}
			return 0;
		},
		// Assurance chômage
		unemployment_insurance: function () {
			return this.salary * 0.00024;
		},
		// CSG imposable
		csd_taxable: function () {
			return this.salary * 0.9825 * 0.024;
		},
		// CSG non imposable
		csd_no_taxable: function () {
			return this.salary * 0.9825 * 0.068;
		},
		// CRDS
		crds: function () {
			return this.salary * 0.9825 * 0.005;
		},
		// Total Expenses
		total_expenses: function () {
			return this.uncapped_social_security + this.capped_social_security + this.complementary_health_tranche_1 + this.complementary_health_tranche_2 + this.unemployment_insurance + this.csd_taxable + this.csd_no_taxable + this.crds;
		},
		// Net salary
		net_salary: function () {
			return this.salary - this.total_expenses;
		},
		// Taxable salary
		taxable_salary: function () {
			return this.net_salary + this.csd_taxable + this.crds;
		},
		// Impôt sur le revenu
		witholding_income_tax: function () {
			let range_1 = 10225 / 12, // 852.08
				range_2 = 26070 / 12, // 2172.50
				range_3 = 74545 / 12, // 6212.08
				//range_4 = 160336/12, // 13361.33
				procent_1 = 11 / 100,
				procent_2 = 30 / 100,
				procent_3 = 41 / 100,
				summ = 0;

			if (this.taxable_salary > range_1) {
				let middle;
				if (this.taxable_salary > range_2) {
					middle = range_2 - range_1;
				} else {
					middle = this.taxable_salary - range_1;
				}
				summ = summ + middle * procent_1;
			}

			if (this.taxable_salary > range_2) {
				let middle;
				if (this.taxable_salary > range_3) {
					middle = range_3 - range_2;
				} else {
					middle = this.taxable_salary - range_2;
				}
				summ = summ + middle * procent_2;
			}

			if (this.taxable_salary > range_3) {
				let middle;
				//if (this.taxable_salary > range_4) {
				// middle = range_4 - range_3;
				//} else {
				middle = this.taxable_salary - range_3;
				//}
				summ = summ + middle * procent_3;
			}

			return summ;
		},
		// Total net income
		total_net_income: function () {
			return this.net_salary - this.witholding_income_tax;
		},
		all_taxes: function () {
			return this.salary - this.total_net_income;
		},
	},
	methods: {
		setBrutto(val) {
			this.brutto = val;
		},
		setPeriodMonth(val) {
			this.month_period = val;
		},
		setSalary(val) {
			this.salary = val;
		},
	},
};
</script>
